export default __webpack_public_path__ + "static/media/map.033cabf0.png";